import { MultilingualFactory } from './../common/multilingual.interface.factory';
import { MediaFactory, MediaFlatFactory } from '../media';
import { TECH_SOURCES, TECH_TYPES } from './tech.interface';
// Tech
// -----------------------------------------------------------------------------
export class TechFactory {
    static create(props = {}) {
        const defaultProps = {
            id: 1,
            name: 'JavaScript',
            info: MultilingualFactory.create(),
            acronym: 'JS',
            icon: MediaFactory.create(),
            iconId: 1,
            source: TECH_SOURCES[0],
            status: TECH_TYPES[0]
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 1) {
        return Array.from({ length }).map(() => this.create());
    }
}
// TechFlat
// -----------------------------------------------------------------------------
export class TechFlatFactory {
    static create(props = {}) {
        const defaultProps = {
            ...TechFactory.create(),
            info: 'My info',
            icon: MediaFlatFactory.create()
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 1) {
        return Array.from({ length }).map(() => this.create());
    }
}
//# sourceMappingURL=tech.interface.factory.js.map